import { AppThunk } from '../../../store/rootReducer';
import { createModeSelector } from '../selectors/create.selectors';
import { CreateMode } from '../utils/create.utils';
import * as createActions from '../actions/create.actions';

export const setCreateMode = (mode: CreateMode): AppThunk => (
  dispatch,
  getState,
) => {
  const createMode = createModeSelector(getState());

  if (createMode !== mode) {
    dispatch(createActions.setMode({ mode, meta: { history: false } }));
  }
};
